/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.modalpage': {
      maxWidth: '450px !important',
      width: '50%',
      borderRadius: pxToEm(12),
      '& .close': {
        display: 'none'
      }
    },
    '.deleteproductgroupmodal': {
      textAlign: 'center',
      overflowY: 'auto',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '20px'
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        color: themeV2.color.base.gray.dark,
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      },
      '& .errormessage': {
        display: 'block',
        color: themeV2.color.error.main
      },
      '& .tip': {
        color: themeV2.color.error.main
      }
    }
  }
});
